import { Box, Breadcrumbs, useMediaQuery, Button } from "@material-ui/core";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { useDispatch, useSelector } from "react-redux";

import { CheckoutStepType } from "../checkoutPage.constants";
import { useStyles } from "../checkoutPage.styles";
import { RootState } from "../../../app/rootReducer";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { updateTabSelected } from "../../../store/checkoutPage.slide";

export const CheckoutBreadcrumb = ({ checkoutSteps }: { checkoutSteps: CheckoutStepType[] }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { isMoreThanSm } = useBreakpoint();
  const matches = useMediaQuery("(max-width:400px)");
  const matchesSmallMobile = useMediaQuery("(max-width:360px)");

  const { tabSelected } = useSelector((state: RootState) => state.checkout);

  return (
    <Box pb={isMoreThanSm ? "37px" : 0} bgcolor={!isMoreThanSm ? "#fff" : "transparent"}>
      <Breadcrumbs
        className={classes.breadcrumb}
        separator={<NavigateNextIcon fontSize="small" className={classes.breadcrumbSeparator} />}
        aria-label="breadcrumb"
      >
        {checkoutSteps.map((item, i) => (
          <Button
            key={i}
            className={`${classes.breadcrumbItem} ${tabSelected === item.id ? classes.breadcrumbItemActive : ""} ${
              matches ? classes.fontSizeSm : ""
            }`}
            style={
              matchesSmallMobile
                ? {
                    margin: "4px 4px 0px"
                  }
                : {}
            }
            onClick={() => dispatch(updateTabSelected(item.id))}
          >
            {i + 1}. {item.breadcrumb}
          </Button>
        ))}
      </Breadcrumbs>
    </Box>
  );
};
